import { useState } from "react"
import { OPACITY_HIGHLIGHT_LEVELS } from "../../consts/modules/graphics.consts"
import { debounce } from "lodash"

/**
 * Custom hook to manage line chart data highlighting on legend hover
 *
 * @param {Array} initialData
 * @returns
 */
const useHighlightLineChartData = ({
  lineLabels = [],
  highlightLevels = {
    highlighted: OPACITY_HIGHLIGHT_LEVELS.HIGHLIGHTED,
    notHighlighted: OPACITY_HIGHLIGHT_LEVELS.NOT_HIGHLIGHTED,
  },
}) => {
  const [data, setData] = useState(
    lineLabels.reduce((acc, label) => {
      acc[label] = {
        opacity: highlightLevels.highlighted,
      }
      return acc
    }, {})
  )
  const debouncedSetData = debounce(setData, 50)

  const handleMouseEnterLegend = (e) => {
    const hoveredLegend = e?.currentTarget?.dataset?.name
    debouncedSetData((prevData) => {
      const newData = { ...prevData }
      Object.keys(newData).forEach((key) => {
        if (key === hoveredLegend) {
          newData[key].opacity = highlightLevels.highlighted
        } else {
          newData[key].opacity = highlightLevels.notHighlighted
        }
      })
      return newData
    })
  }
  const handleMouseLeaveLegend = (e) => {
    debouncedSetData((prevData) => {
      const newData = { ...prevData }
      Object.keys(newData).forEach((key) => {
        newData[key].opacity = highlightLevels.highlighted
      })
      return newData
    })
  }

  return {
    data,
    setData,
    handleMouseEnterLegend,
    handleMouseLeaveLegend,
  }
}

export default useHighlightLineChartData
